import {PhpVersionFormState} from './PhpVersionForm-State'
import {errorsList, errorsPresent, mergeServerValidationErrors} from '../../../../helpers/ErrorHelper'
import {endOfURL} from '../../../../helpers/UrlHelper'
import {isObject} from "../../../../helpers/DataHelper";

export default function phpVersionFormReducer(state = PhpVersionFormState, action) {

    let {data} = {...state};
    let {
        validationErrors,
        name,
        value,
        error,
        site_id,
        search_term,
        amount_of_terms,phpVersion
    } = action;
    switch (action.type) {

        case 'ON-PHP-VERSION-FORM-CHANGE':
            data.payload[name] = value;
            buildErrors();
            return {...state, data};

        case 'SET-PHP-VERSION-ERROR':
            data.message = error;
            buildErrors();
            return {...state, data};

        case 'SET-SITE-ID':
            data.site_id = site_id;
            buildErrors();
            return {...state, data};

        case 'ON_SEARCH_NOTIFICATION':
            data.amount_of_terms = amount_of_terms;
            data.search_item_name = search_term;
            buildErrors();
            return {...state, data};

        case 'SET-DEFAULT-PHP-VERSION-FORM':
            data = {
                payload: {
                    php_version: phpVersion || '',
                },
                errors: [],
                errorsPresent: false,
                submitted: false,
                dispatchAPI: false,
                mode: endOfURL(),
                message: ``
            };
            buildErrors();
            return {...state, data};

        case 'CANCEL-PHP-VERSION-FORM-DISPATCH':
            data.dispatchAPI = false;
            data.submitted = false;
            buildErrors();
            return {...state, data};

        case 'ON-PHP-VERSION-FORM-SUBMIT':
            data.submitted = true;
            buildErrors();
            if (!data.errorsPresent) data.dispatchAPI = true;
            return {...state, data};

        case 'PHP-VERSION-FORM-SERVER-VALIDATION-ERRORS':
            validationErrors && isObject(validationErrors) &&
            Object.keys(validationErrors).map(key =>
                data.errors[key] = [{message: ` ${validationErrors[key][0]}`}]
            );
            data.errorsPresent = true;
            data.dispatchAPI = false;
            return {...state, data};

        default:
            return state
    }

    function buildErrors() {
        data.errors = errorsList(errors)
        data.errorsPresent = errorsPresent(errors)
    }

    function errors(field) {
        let {payload, submitted, validationErrors} = data;
        let errors = {};
        Object.keys(payload).map(key => errors[key] = []);

        if (submitted) {
            if (field === `php_version`) {
                if (!_(field)) newError(field, 0, `This field is required`)
            }
        }

        errors = mergeServerValidationErrors(errors, validationErrors)

        return field ? errors[field] : errors

        function newError(field, step, message) {
            errors && errors[field].push({step, message})
        }

        function _(field) {
            return data.payload[field]
        }
    }
}